<template>
  <div class="steam-list-wrapper">
    <van-sticky>
      <van-tabs v-model="active" @change="changeTabs" sticky background="#fff" title-active-color="#000">
        <van-tab v-for="(item,index) in tabList" :title="item" :key="index"></van-tab>
      </van-tabs>
    </van-sticky>

    <div class="steam-list-content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="loadInfo" offset="0">
          <div v-if="steamAppointmentList.length>0">
            <div v-for="item in steamAppointmentList" :key="item.id">
              <steam-appointment-item :appointmentItem="item" @cancelAppointmentP="cancelAppointmentP" @goSteamWechatPay="choosePayMethod"/>
            </div>
          </div>
          <div v-else class="empty-state">
            <van-empty description="暂无预约数据" />
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="showPayMethod" round closeable position="bottom" :style="{ height: '12rem' }">
      <div class="pay-method-popup">
        <div class="popup-title">选择支付方式</div>
        <div class="pay-method-options">
          <van-radio-group v-model="payMethod">
            <van-cell-group>
              <van-cell v-if="isShowCarBind" title="公司统一支付" clickable @click="payMethod = '1'" class="pay-option">
                <template #icon>
                  <van-icon name="balance-list-o" class="option-icon" />
                </template>
                <template #right-icon>
                  <van-radio name="1" checked-color="#4080ff" />
                </template>
              </van-cell>
              <van-cell v-if="!isShowCarBind" title="个体支付" clickable @click="payMethod = '2'" class="pay-option">
                <template #icon>
                  <van-icon name="paid" class="option-icon" />
                </template>
                <template #right-icon>
                  <van-radio name="2" checked-color="#4080ff" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="pay-button">
          <van-button type="primary" block round @click="onConfirmPayMethod" :loading="yyloading">确认支付</van-button>
        </div>
      </div>
    </van-popup>

    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from "@/views/Public/tabbarTpl.vue";
import SteamAppointmentItem from "@/components/SteamComponents/steamAppointmentItem.vue";
import steamApi from "@/fetch/steamApi.js";
import { Toast,Dialog } from "vant";
export default {
  components: {
    Tabbar,SteamAppointmentItem,
  },
  data()
  {
    return {
      page:1,
      active:0,
      steamAppointmentList:[],
      tabList:['全部','待支付','待审核','待作业','退款'],
      loading: false,
      finished: false,
      refreshing: false,
      showPayMethod:false,
      chooseId:"",
      payMethod:"1",
      yyloading:false,
      isShowCarBind: true,
    }
  },
  inject: ['reload'],
  created()
  {
    document.title = "预约记录列表";
    var type = "all";
    switch (this.active) {
      case 0://所有
        type = "all";
      break;
      case 1:
        type = "dzf";
      break;
      case 2:
        type = "dsh";
      break;
      case 3:
        type = "dcl";
      break;
      case 4:
        type = "tk";
      break;
    }
    this.getSteamAppointmentList(type,1);
  },
  methods:{
    getSteamAppointmentList(type,page)
    {
      var that = this;
      if(page == 1)
      {
        that.steamAppointmentList = [];
      }

      var openid = that.$store.state.wx_info.openid;

      let formData = new FormData();
      formData.append("openid", openid);
      formData.append("pageNo", page);
      formData.append("type", type);
      steamApi.getSteamAppointmentList(formData).then(function(res) {
        that.refreshing = false;
        that.loading = false;
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var steamAppointmentList = resData.data;
          console.log(1111111, steamAppointmentList)
          if(steamAppointmentList.length>0)
          {
            steamAppointmentList.forEach((item) => {

              switch (item.bpmStatus) {
                case "1":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '未提交';
                break;
                case "2":
                  item.bpmStatusType = 'danger';
                  item.bpmStatusTitle = '待支付';
                break;
                case "4":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '市场部待审核';
                break;
                case "5":
                  item.bpmStatusType = 'danger';
                  item.bpmStatusTitle = '市场部审核失败';
                break;
                case "7":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '洗车人员待审核';
                break;
                case "8":
                  item.bpmStatusType = 'danger';
                  item.bpmStatusTitle = '洗车人员审核失败';
                break;
                case "10":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '待作业';
                break;
                case "11":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '作业中';
                break;
                case "12":
                  item.bpmStatusType = 'success';
                  item.bpmStatusTitle = '作业完成';
                break;
                case "101":
                  item.bpmStatusType = 'danger';
                  item.bpmStatusTitle = '取消预约未退款';
                break;
                case "102":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '取消预约成功';
                break;
                case "103":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '审核失败未退款';
                break;
                case "104":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '审核失败退款成功';
                break;
                case "105":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '取消预约成功';
                break;
                case "106":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '审核失败';
                break;
                case "107":
                  item.bpmStatusType = 'warning';
                  item.bpmStatusTitle = '退款中';
                break;
                case "108":
                  item.bpmStatusType = 'default';
                  item.bpmStatusTitle = '业务退款';
                  break;
                
              }

              switch (item.compartmentCount) {
                case "01":
                  item.cangshiTitle = "单舱";
                  break;
                case "02":
                  item.cangshiTitle = "双舱";
                  break;
                case "03":
                  item.cangshiTitle = "三舱";
                  break;
                  default:
                  item.cangshiTitle = "";
              }

              that.steamAppointmentList.push(item);
            });
          }
          else{
            that.finished = true;
            that.loading = false;
          }
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });

    },
    changeTabs()
    {
      var type = "all";
      switch (this.active) {
        case 0://所有
          type = "all";
        break;
        case 1:
          type = "dzf";
        break;
        case 2:
          type = "dsh";
        break;
        case 3:
          type = "dcl";
        break;
        case 4:
          type = "tk";
        break;
        default:
      }
      this.getSteamAppointmentList(type,1);
    },
    cancelAppointmentP(appointmentId)
    {
      var that = this;
      var userid = that.$store.state.userid;
      if(appointmentId)
      {
        Dialog.confirm({
          message: '您是否确认要取消订单',
        })
          .then(() => {
            // on confirm
            let formData = new FormData();
            formData.append("id", appointmentId);
            formData.append("userId", userid);
            steamApi.cancelAppointment(formData).then(function(resData) {
              var res = JSON.parse(resData);
              if (res.respCode == 0) {
                that.onRefresh();
                Toast.success(res.data);
              }
              else{
                Toast.fail(res.message);
              }
            }).catch(function(err) {
              console.log(err);
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    onRefresh() {
      this.page = 1;
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.changeTabs();
    },
    loadInfo()
    {
      var type = "all";
      switch (this.active) {
        case 0://所有
          type = "all";
        break;
        case 1:
          type = "dzf";
        break;
        case 2:
          type = "dsh";
        break;
        case 3:
          type = "dcl";
        break;
        case 4:
          type = "tk";
        break;
        default:
      }
      this.page ++ ;
      this.getSteamAppointmentList(type,this.page);
    },
    //调接口判断车辆是否有公司
    async getCarBound(headstock) {
      try {
        const res = await steamApi.getController(headstock);
        const resData = JSON.parse(res)
        if(resData) {
          this.isShowCarBind = resData.success
        }
        if (!this.isShowCarBind) {
          this.payMethod = '2'
        } else {
          this.payMethod = '1'
        }
      } catch (error) {
        Toast.fail('连接失败，请刷新页面')
        return false;
      }
    },
    async choosePayMethod(appointmentId)
    {
      this.chooseId = appointmentId;
      
      const appointmentItem = this.steamAppointmentList.find(item => item.id === appointmentId);
      if (appointmentItem) {
        // 调用接口判断是否显示车辆绑定
        await this.getCarBound(appointmentItem.headstock);
      }

      this.showPayMethod = true;
    },
    onConfirmPayMethod()
    {
      var appointmentId = this.chooseId;
      var payMethod = this.payMethod;
      if(appointmentId)
      {
        if(payMethod == '1')//对公支付
        {
          this.payByCompany(appointmentId);
        }
        else if(payMethod == '2'){//个体支付
          this.goSteamWechatPay(appointmentId);
        }
      }
    },
    payByCompany(appointmentId)
    {
      var that = this;
      var postData = {
        id:appointmentId,
        driverId:that.$store.state.userid,
      };
      steamApi.payByCompany(postData).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          Dialog.alert({
            message: '支付成功',
          }).then(() => {
            // on close
            that.reload();
          });
        }
        else{
          Dialog.alert({
            message: '支付失败，请到订单页进行支付',
          }).then(() => {
            // on close
            that.reload();
          });
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    goSteamWechatPay(appointmentId)
    {
      var that = this;
      var postData = {
        openid:that.$store.state.wx_info.openid,
        userId:that.$store.state.userid,
        username:that.$store.state.wx_info.username
      };
      steamApi.steamWechatPayCreateOrder(appointmentId,postData).then(function(res) {
        var resData = JSON.parse(res);

        if (resData.respCode == "0") {

          const weixinJSBridge = window.WeixinJSBridge;
          weixinJSBridge.invoke(
          "getBrandWCPayRequest", {
          "appId": resData.data.appid, // 公众号名称，由商户传入
          "timeStamp": resData.data.timeStamp, // 时间戳，自1970年以来的秒数
          "nonceStr": resData.data.nonceStr, // 随机串
          "package": "prepay_id="+resData.data.prepayId,
          "signType": resData.data.signType, // 微信签名方式
          "paySign": resData.data.paySign // 微信签名
        },
        function(res) {
            // 支付成功
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            that.reload();
            // 支付成功逻辑
            Toast('支付成功')

          }
          // 支付过程中用户取消
          else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            // 取消支付逻辑

            Toast('取消支付')


          }
          // 支付失败
          else if (res.err_msg === "get_brand_wcpay_request:fail") {
            // 失败逻辑
            Toast('支付失败')
          }
          // 其它错误处理
          else if (res.err_msg === "调用支付JSAPI缺少参数：total_fee") {
            // 错误处理逻辑
            Toast('支付错误')
          }
        });

        }
        else{
          Toast.fail(resData.message);
          that.yyloading = false;
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.steam-list-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 50px;
}

.steam-list-content {
  padding: 12px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  //background-color: #fff;
  margin: 12px 0;
  border-radius: 12px;
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.pay-method-popup {
  padding: 16px;
  
  .popup-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #323233;
    margin-bottom: 16px;
  }
  
  .pay-method-options {
    .pay-option {
      margin-bottom: 8px;
      border-radius: 8px;
      
      .option-icon {
        margin-right: 8px;
        font-size: 20px;
        color: #4080ff;
      }
    }
  }
  
  .pay-button {
    margin-top: 24px;
    
    .van-button {
      height: 44px;
      font-size: 16px;
      background-color: #4080ff;
      border: none;
    }
  }
}
</style>
